/* src/app/components/pages/checkout/checkout.component.scss */
.bodyCheck {
  background-color: #ebebeb;
}
.bodyCheck #checkOut {
  max-width: 1365px;
  margin: auto;
  padding: 16px;
}
.bodyCheck #checkOut .main .mat-mdc-card {
  padding: 16px 0px 16px 0px;
}
.bodyCheck #checkOut .main .header {
  color: #5e5e5e;
  font-size: 23px;
}
.bodyCheck #checkOut .main .f-bold {
  font-weight: 700 !important;
  color: #5e5e5e;
  font-size: 13px;
}
.bodyCheck #checkOut .main .viewAddress {
  margin-bottom: 18px;
  font-style: normal;
  line-height: 1.42857143;
}
.bodyCheck #checkOut .main .editButton {
  color: #2196f3;
  font-size: 14px;
}
.bodyCheck #checkOut .main .applyButton .mat-mdc-button {
  color: #787878;
  font-size: 13px;
  background-color: #c6c6c6;
  padding: 0px 20px;
  margin: 15px 0px 0px 15px;
}
.bodyCheck #checkOut .main .coupon_error {
  top: 44px;
  position: absolute;
}
.bodyCheck #checkOut .main .borderBottom {
  border-bottom: 1px solid #cfcfcf;
}
.bodyCheck #checkOut .main .cart-items__header {
  border-bottom: 1px solid #c3c3c3;
  padding-bottom: 10px;
  text-transform: uppercase;
}
.bodyCheck #checkOut .main .order-total-summary {
  line-height: 25px;
}
.bodyCheck #checkOut .main .order-items-total {
  border-top: 1px solid #cfcfcf;
  padding-top: 15px;
}
.bodyCheck #checkOut .main .items {
  padding-bottom: 15px;
  margin-top: 15px !important;
}
.bodyCheck #checkOut .main .items .cart-items__images {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  overflow: hidden;
  flex: 0 0 90px;
}
.bodyCheck #checkOut .main .items .cart-items__images img {
  border-radius: 0;
  width: 100%;
  height: auto;
  margin: 0;
  flex-shrink: 0;
  max-width: 70px;
  max-height: 70px;
}
.bodyCheck #checkOut .main .items .md-avatar:first-child,
.bodyCheck #checkOut .main .items .-inner > .md-avatar:first-child {
  border-radius: 0;
  width: 90px;
  height: 90px;
}
.bodyCheck #checkOut .main .items .md-secondary-container {
  top: 87%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 10px;
}
.bodyCheck #checkOut .main .items .input-group {
  width: 88px;
  line-height: 0;
  margin-top: 10px;
}
.bodyCheck #checkOut .main .items .input-group .input-group-btn button {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 30px;
  box-shadow: none;
}
.bodyCheck #checkOut .main .items .input-group .input-control {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 28px;
  text-align: center;
  color: #1c7bbf;
}
.bodyCheck #checkOut .main .items .md-button.remove-items {
  position: absolute;
  top: -10px;
  right: 0;
}
.bodyCheck #checkOut .main .items mat-divider {
  left: 50px;
  bottom: -1px;
}
.bodyCheck #checkOut .main .itemName {
  color: #2196f3;
  font-size: 14px;
}
@media only screen and (max-width: 600px) {
  .bodyCheck #checkOut .backButtom .mat-mdc-button {
    width: 375px;
  }
}
.bodyCheck #checkOut .color-f-s-14 {
  color: #5e5e5e;
  font-size: 14px;
}
.bodyCheck #checkOut .p-l-r-15 {
  padding: 0px 15px;
}
.bodyCheck #checkOut .color2-f-s-14 {
  color: #777777;
  font-size: 14px;
}
.bodyCheck #checkOut .m-b-10 {
  margin-bottom: 10px !important;
}
.bodyCheck #checkOut .p-t-16 {
  padding-top: 16px !important;
}
.bodyCheck #checkOut .color-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}
#checkOut .mat-mdc-standard-chip .mat-chip-remove.mat-icon,
.mat-standard-chip .mat-chip-remove .mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
::ng-deep .mat-mdc-checkbox,
.mat-mdc-raised-button {
  font-family: "IBM Plex Sans", sans-serif !important;
}
.disp {
  top: 7px;
  position: relative;
}
/*# sourceMappingURL=checkout.component.css.map */
